import { store } from '@/state/store';
import { DTO__file_data } from '@shared/dto/+image/image_asset_base/DTO__file_data';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { UTILS__graph_data } from '../UTILS__graph_data';
import { UTILS__upload } from '../utils_upload';

export async function FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph(file_data: DTO__file_data, field: FIELD__image_asset) {
  //need to get generation_current here, before first await because it could be changed
  let { generation_current } = store.getState().slice_generation;

  /*
   * PREPARE REQUEST
   */

  let image = await UTILS__upload.image_to_workspace([file_data], field.category, generation_current.workspace_id);
  if (image.is_stub()) return;

  /*
   * HANDLE RESPONSE
   */

  let graph_new = generation_current.tool.graph.clone();

  let field_new = field.clone();
  field_new.image__asset_use(image.clone());

  graph_new.field__replace(field_new);

  /*
   * CLEAR IMAGE MASK
   */

  let field_mask = graph_new.field_image__get_mask_for(field);
  if (!field_mask.is_stub()) {
    let field_mask_new = field_mask.clone();
    field_mask_new.image__clear();

    graph_new.field__replace(field_mask_new);
  }

  await UTILS__graph_data.update(graph_new);
}
